import { cn } from '@playbooks/ui/lib/utils'
import { InputProps } from '../types'
import { Textarea } from '@playbooks/ui/components/textarea'
import { useAppContext } from '../../../contexts/AppContext'
import { ViewMode } from '@playbooks/action-cards-utils/src'

export default function LongTextInput({ question, onChange, invalid }: InputProps) {
  const {settings: {viewMode}} = useAppContext()
  const isDocumentView = viewMode === ViewMode.DOC
  
  return (
    <Textarea
      id={`question-${question.id}`}
      placeholder=""
      // The operator `??` prevents uncontrolled to controlled input warning
      value={(question.value as string) ?? ''}
      onChange={e => onChange(e.target.value)}
      aria-invalid={invalid}
      required={question.required}
      className={cn(isDocumentView && 'rounded-none')}
    />
  )
}
